'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:inject:load');
}

var _invoke = require('../invoke');

/**
 * 打开一个隐藏 webview
 *
 * 如果指定的 `name` 还不存在，会创建一个新的 webview。
 * 如果指定的 `name` 存在，会在该 webview 上加载新的 url。
 * 在加载页面所有静态资源请求都完成时，Promise resolve。
 * 但是不保证页面已经可用，业务方可自己进行 domready 等检测。
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof inject
 * @static
 * @name load
 * @param {String} name 隐藏 webview 名
 * @param {String} url 需要加载的页面地址
 * @return {Promise}
 * @example
 *  hbnb.inject.load(
 *      'name',
 *      'https://kyfw.12306.cn/otn/leftTicket/init'
 *  ).then(function() {
 *      console.log('loaded');
 *  });
 */
module.exports = function(name, url) {
    if (process.env.NODE_ENV !== 'production') {
        debug('name is %s', name);
        debug('url is %s', url);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('inject', 'load', {
            name: name,
            url: url,
            callback: function() {
                resolve();
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/inject/load.js
// module id = 589
// module chunks = 0